import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const initial = { name: "", email: "", phone: "", company: "", message: "" };

const labelStyle = {
  fontFamily: "Poppins, sans-serif",
  fontWeight: 500,
  letterSpacing: "0.06em",
};
const labelClass = "block mb-2 text-[10px] uppercase text-[color:var(--bpm-muted)]";

export const Contact = () => {
  const [form, setForm] = useState(initial);
  const [submitting, setSubmitting] = useState(false);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please share your name, email, and a short note.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/contacts`, form);
      toast.success("Thank you, we will be in touch soon.");
      setForm(initial);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="section-divider relative" style={{ background: "var(--bpm-night-2)" }} data-testid="contact-section">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-10 md:py-14 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl">
            Let&apos;s Connect
          </h2>
          <p className="mt-7 text-[16px] leading-[1.75] text-[color:var(--bpm-cream-soft)] max-w-md">
            We&apos;re here to make your life easier, solve problems, and
            ensure your communications click. Interested? Drop a line for a
            quick, no-pressure consultation.
          </p>
        </div>

        <form className="lg:col-span-7" onSubmit={onSubmit} data-testid="contact-form" noValidate>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
            <label className="block">
              <span className={labelClass} style={labelStyle}>Name</span>
              <input className="input" name="name" type="text" value={form.name} onChange={onChange} placeholder="Your name" data-testid="contact-input-name" />
            </label>
            <label className="block">
              <span className={labelClass} style={labelStyle}>Email</span>
              <input className="input" name="email" type="email" value={form.email} onChange={onChange} placeholder="you@company.com" data-testid="contact-input-email" />
            </label>
            <label className="block">
              <span className={labelClass} style={labelStyle}>Phone Number</span>
              <input className="input" name="phone" type="tel" value={form.phone} onChange={onChange} placeholder="" data-testid="contact-input-phone" />
            </label>
            <label className="block">
              <span className={labelClass} style={labelStyle}>Company</span>
              <input className="input" name="company" type="text" value={form.company} onChange={onChange} placeholder="" data-testid="contact-input-company" />
            </label>
            <label className="block md:col-span-2">
              <span className={labelClass} style={labelStyle}>How can we help?</span>
              <textarea className="input" name="message" rows={4} value={form.message} onChange={onChange} placeholder="" data-testid="contact-input-message" />
            </label>
          </div>
          <div className="mt-10">
            <button type="submit" className="btn" disabled={submitting} data-testid="contact-submit">
              {submitting ? (<><Loader2 size={16} className="animate-spin" /> Sending</>) : (<>Send note <ArrowRight size={16} /></>)}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default Contact;
